/* eslint-disable no-use-before-define */
import { Window } from '../../00_IMMEDIATE/Window';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';
import { GiftGraphic } from './GiftUI/GiftGraphic';

class Window_TreasureHuntEvent extends Window {
  constructor(parent) {
    super(parent);

    this.treasureHuntMgr = G.TreasureHunt.treasureHuntMgr;
    this.generalEventInfo = this.treasureHuntMgr.getGeneralEventInfo();

    this._initLayout();

    G.sb('hideMainHighscorePanel').dispatch();
    OMT.platformTracking.logEvent(OMT.platformTracking.Events.TreasureHuntPanelVisible);
  }

  /**
   * Creating and positioning layout elements.
   */
  _initLayout() {
    // the window and backdrop image
    const bg = this.add(new G.PopUpFlexBg());
    bg.y = 90; // offset because the mascot and treasure chest should be above the window
    //bg.x = 50;
    //bg.changeSize(G.OMTsettings.elements.Window_treasureHuntEvent.bgSize, true);

    const headerGroup = game.add.group(this);
    const ginger = G.makeImage(-65, -210, 'Cookie_Pirate_Header', [0.5, 1], headerGroup);
    ginger.scale.set(0.9);
    G.makeImage(0, -177, 'Treasure_Hunt_header', 0.5, headerGroup);
    headerGroup.add(new G.Text(0, -177, OMT.language.getText('Treasure Hunt'), {
      style: 'font-white',
      fontSize: 60,
    }, 0.5, 310));
    G.makeImage(76, -294, 'Chest_Full', 0.5, headerGroup);

    this.add(new G.Button(235, -170, 'btn_x', this.closePopUp, this));

    const clock = this.add(new G.CommonObjects.ClockTimer(0, -70));
    clock.setEndDate(Date.now() + this.generalEventInfo.duration);

    // adding content below the clock
    const pageGroup = game.add.group(this);

    pageGroup.unlockTxt = pageGroup.add(new G.Text(0, 0,
      OMT.language.getText('You unlocked a special event!'), {
        style: 'font-purple',
        fontSize: 30,
      }, 0.5, 520));

    let desc = OMT.language.getText('Open [AMOUNT] Treasure Chests in [DAYS_NR] days to get a Cookie Chest!');
    desc = desc.replace('[AMOUNT]', this.generalEventInfo.gemsTarget);
    desc = desc.replace('[DAYS_NR]', this.generalEventInfo.durationDays);

    pageGroup.descTxt = pageGroup.add(new G.Text(0, 70, desc, {
      style: 'font-purple',
      fontSize: 25,
    }, 0.5, 450, 100, true, 'center'));

    pageGroup.gem = G.makeImage(-160, 180, 'gem5_small', 0.5, pageGroup);
    pageGroup.arrow1 = G.makeImage(-80, 180, 'arrow_right', 0.5, pageGroup);
    pageGroup.treasureChest = G.makeImage(0, 180, 'Chest_Full', 0.5, pageGroup);
    pageGroup.treasureChest.scale.setTo(0.65);
    pageGroup.arrow2 = G.makeImage(80, 180, 'arrow_right', 0.5, pageGroup);
    pageGroup.chest = new GiftGraphic(180, 180, { giftType: 1, useFullGift: true }, pageGroup);
    // pageGroup.chest = G.makeImage(160, 180, 'prezent', 0.5, pageGroup);
    pageGroup.chest.scale.setTo(0.65);
    G.centerElements([
      pageGroup.gem,
      pageGroup.arrow1,
      pageGroup.treasureChest,
      pageGroup.arrow2,
      pageGroup.chest,
    ], 10);

    // big play button
    const button = new OMT_UI_SquareButton(0, 320, {
      button: {
        tint: BUTTONCOLOURS.purple,
        dimensions: {
          width: 309,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Play'),
        textStyle: { style: 'font-white', fontSize: 64 },
      },
      options: {
        clickFunction: {
          onClick: this.onBtnClicked.bind(this),
        },
      },
    });
    this.add(button);

    const windowPanel = this.add(
      new G.TreasureHunt.TreasureHuntWindowPanel({
        tutorial: true,
      }),
    );
    windowPanel.y = 435;
  }

  /**
   * Start the level, or notify the user that they dont have enough lives to start the level.
   */
  async onBtnClicked() {
    console.log('treasure hunt window');

    // Check unopened gate status first
    const { gatesMgr } = G.Helpers;
    const nextLevel = G.saveState.getLastPassedLevelNr() + 1;
    let gateData = gatesMgr.getFirstClosedGateData();

    const canUnlock = []; // gates that can be unlocked automatically
    const cannotUnlock = { // gates that can't be unlocked automatically
      gateObject: null,
      gateId: null,
    };
    let scrollToLvl = nextLevel;

    // Check for which gates can be unlocked automatically
    while (gateData && nextLevel >= gateData.lvlNr) {
      const gateObject = gatesMgr.getGateObject(gateData.id);
      gatesMgr.activateGate(gateData.id);

      if (gateObject.isReadyToOpen()) {
        canUnlock.push(gateData.id);
        scrollToLvl = gateData.lvlNr;
      } else {
        cannotUnlock.gateObject = gateObject;
        cannotUnlock.gateId = gateData.id;
        scrollToLvl = gateData.lvlNr;
        break;
      }

      gateData = gatesMgr.getNextGateData(gateData.id);
    }

    // Close this pop-up
    this.closePopUp();

    // Scroll to furthest gate possible if next level is behind gate
    gateData = gatesMgr.getFirstClosedGateData();
    if (gateData && nextLevel >= gateData.lvlNr) {
      // Close side panel if open
      if (game.state.getCurrentState().worldSidePanel.getSidePanelState()) {
        game.state.getCurrentState().worldSidePanel.toggleSidePanel();
      }
      await new Promise((resolve) => game.state.getCurrentState().map.scrollToPoint({ lvlNr: scrollToLvl - 1 }, () => resolve(), this));
    }

    // Try to unlock all gates that meet star requirements on their behalf
    for (const gateId of canUnlock) {
      // Dispatch and remove the open gate signal only if the gate exists
      // Don't push the Treasure Hunt Window since it will be pushed later
      if (gatesMgr.instances[gateId].onOpen) {
        gatesMgr.instances[gateId].onOpen.dispatch(gateId, false);
      } else {
        console.warn(`Treasure Hunt side panel tried to open Gate #${gateId}, but it doesn't exist`);
        return;
      }
    }

    // If there is a gate with unmet star requirements, show new gate Window
    if (cannotUnlock.gateObject) {
      // Determine if the treasure hunt window should be shown
      const nextGateLvl = gatesMgr.getNextGateData(cannotUnlock.gateId).lvlNr;
      const showTreasureHuntWindow = nextGateLvl > nextLevel;

      this._openGateWindow(
        cannotUnlock.gateObject,
        gatesMgr.instances[cannotUnlock.gateId],
        cannotUnlock.gateId,
        showTreasureHuntWindow,
      );
      return;
    }

    // Show treasure hunt window
    if (this.treasureHuntMgr.isEventReadyToStart()) {
      this.treasureHuntMgr.startEvent();
    }
    if (G.saveState.getLives() === 0 && G.saveState.getUnlimitedLivesSec() === 0) {
      this.closePopUp();
      G.sb('pushWindow').dispatch(['notEnoughLives'], false, G.WindowMgr.LayerNames.AboveHighScorePanel);
    } else {
      const lvlIndex = this.treasureHuntMgr.getTreasureHuntLevelIndex();
      if (lvlIndex !== null) {
        G.sb('pushWindow').dispatch([
          'level', lvlIndex,
        ]);
      }
      this.closePopUp();
    }
  }

  // Helper function for opening new gate window to avoid "no-loop-func" ESLint rule
  _openGateWindow(gateObject, gateInstance, gateId, showTreasureHuntWindow) {
    G.sb('pushWindow').dispatch(['gateNew', {
      gateObject,
      onOpenCallback: () => {
        gateInstance.unlock();
        gateInstance.onOpen.dispatch(gateId, showTreasureHuntWindow);
      },
    }]);
  };

  closePopUp() {
    // TODO: avoid that, mediator should take care
    G.sb('showMainHighscorePanel').dispatch();
    this.closeWindow();
  }
}
// create global references
if (!window.Windows) window.Windows = {};
Windows.treasureHuntEvent = Window_TreasureHuntEvent;
